import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client, BASE_URL } from '../api/client';
import { getThunkName, showThunkName, createThunkName, updateThunkName, deleteThunkName } from './base';

export const thunkPerformanceAchievementApi = 'api/kelola-sasaran-perkin';
export const slicePerformanceAchievementName = 'kelola-sasaran-perkin';
export const thunkPerformanceAchievementListEmployeeApi = 'api/kelola-sasaran-perkin/pegawai-list';

export const getPerformanceAchievementListEmployee = createAsyncThunk(getThunkName(thunkPerformanceAchievementListEmployeeApi), async (_, { rejectWithValue }) => {
  try {
    const response = await client.get(BASE_URL + thunkPerformanceAchievementListEmployeeApi, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

// Sasaran
export const getPerformanceAchievement = createAsyncThunk(getThunkName(thunkPerformanceAchievementApi), async (params = '', { rejectWithValue }) => {
  try {
    const response = await client.get(BASE_URL + thunkPerformanceAchievementApi + '?' + params, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const showPerformanceAchievement = createAsyncThunk(showThunkName(thunkPerformanceAchievementApi), async (id, { rejectWithValue }) => {
  try {
    const response = await client.get(BASE_URL + thunkPerformanceAchievementApi + '/' + id, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const createPerformanceAchievement = createAsyncThunk(createThunkName(thunkPerformanceAchievementApi), async ({ body }, { rejectWithValue }) => {
  try {
    const response = await client.post(BASE_URL + thunkPerformanceAchievementApi, body, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const updatePerformanceAchievement = createAsyncThunk(updateThunkName(thunkPerformanceAchievementApi), async ({ id, body }, { rejectWithValue }) => {
  try {
    const response = await client.put(BASE_URL + thunkPerformanceAchievementApi + '/' + id, body, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const deletePerformanceAchievement = createAsyncThunk(deleteThunkName(thunkPerformanceAchievementApi), async ({ id }, { rejectWithValue }) => {
  try {
    const response = await client.delete(BASE_URL + thunkPerformanceAchievementApi + '/' + id, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const PerformanceAchievementSlice = createSlice({
  name: slicePerformanceAchievementName,
  initialState: {
    get: {
      data: [],
      status: 'idle',
      message: '',
      error: '',
      pagination: {},
    },
    show: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
    create: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
    update: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
    delete: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
    getEmployee: {
      data: [],
      status: 'idle',
      message: '',
      error: '',
    },
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getPerformanceAchievement.pending, state => {
        state.get.data = [];
        state.get.status = 'loading';
        state.get.message = '';
        state.get.error = '';
        state.get.pagination = {};
      })
      .addCase(getPerformanceAchievement.fulfilled, (state, action) => {
        state.get.data = action.payload.data;
        state.get.status = 'succeeded';
        state.get.message = action.payload.message;
        state.get.error = '';
        state.get.pagination = action.payload.meta;
      })
      .addCase(getPerformanceAchievement.rejected, (state, action) => {
        state.get.data = [];
        state.get.status = 'failed';
        state.get.message = action.payload.message;
        state.get.error = action.payload.error;
        state.get.pagination = {};
      })
      .addCase(createPerformanceAchievement.pending, state => {
        state.create.data = {};
        state.create.status = 'loading';
        state.create.message = '';
        state.create.error = '';
      })
      .addCase(createPerformanceAchievement.fulfilled, (state, action) => {
        state.create.data = action.payload.data;
        state.create.status = 'succeeded';
        state.create.message = action.payload.message;
        state.create.error = '';
      })
      .addCase(createPerformanceAchievement.rejected, (state, action) => {
        state.create.data = {};
        state.create.status = 'failed';
        state.create.message = action.payload.message;
        state.create.error = action.payload.error;
      })
      .addCase(updatePerformanceAchievement.pending, state => {
        state.update.data = {};
        state.update.status = 'loading';
        state.update.message = '';
        state.update.error = '';
      })
      .addCase(updatePerformanceAchievement.fulfilled, (state, action) => {
        state.update.data = action.payload.data;
        state.update.status = 'succeeded';
        state.update.message = action.payload.message;
        state.update.error = '';
      })
      .addCase(updatePerformanceAchievement.rejected, (state, action) => {
        state.update.data = {};
        state.update.status = 'failed';
        state.update.message = action.payload.message;
        state.update.error = action.payload.error;
      })
      .addCase(deletePerformanceAchievement.pending, state => {
        state.delete.data = {};
        state.delete.status = 'loading';
        state.delete.message = '';
        state.delete.error = '';
      })
      .addCase(deletePerformanceAchievement.fulfilled, (state, action) => {
        state.delete.data = action.payload.data;
        state.delete.status = 'succeeded';
        state.delete.message = action.payload.message;
        state.delete.error = '';
      })
      .addCase(deletePerformanceAchievement.rejected, (state, action) => {
        state.delete.data = {};
        state.delete.status = 'failed';
        state.delete.message = action.payload.message;
        state.delete.error = action.payload.error;
      })
      .addCase(showPerformanceAchievement.pending, (state, action) => {
        state.show.data = {};
        state.show.status = 'loading';
        state.show.message = '';
        state.show.error = '';
      })
      .addCase(showPerformanceAchievement.fulfilled, (state, action) => {
        state.show.data = action.payload.data;
        state.show.status = 'succeeded';
        state.show.message = action.payload.message;
        state.show.error = '';
      })
      .addCase(showPerformanceAchievement.rejected, (state, action) => {
        state.show.data = {};
        state.show.status = 'failed';
        state.show.message = action.payload.message;
        state.show.error = action.payload.error;
      })
      .addCase(getPerformanceAchievementListEmployee.pending, state => {
        state.getEmployee.data = [];
        state.getEmployee.status = 'loading';
        state.getEmployee.message = '';
        state.getEmployee.error = '';
      })
      .addCase(getPerformanceAchievementListEmployee.fulfilled, (state, action) => {
        state.getEmployee.data = action.payload.data;
        state.getEmployee.status = 'succeeded';
        state.getEmployee.message = action.payload.message;
        state.getEmployee.error = '';
      })
      .addCase(getPerformanceAchievementListEmployee.rejected, (state, action) => {
        state.getEmployee.data = [];
        state.getEmployee.status = 'failed';
        state.getEmployee.message = action.payload.message;
        state.getEmployee.error = action.payload.error;
      })
  },
});

export default PerformanceAchievementSlice.reducer;
